import React from "react";

import styles from "../ForgotPassword.module.css";

const EmailIcon = () => {
	return (
		<svg
			aria-hidden="true"
			className={styles.emailIcon}
			fill="none"
			focusable="false"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M4 6.75h16v10.5H4V6.75Z" />
			<path d="m4.75 7.5 7.25 5.25 7.25-5.25" />
		</svg>
	);
};

export default EmailIcon;
